/**
 * BrandCardsGrid - Grid wrapper for brand cards
 *
 * Features:
 * - Responsive image-card grid: 2 cols mobile, 3 tablet, 5 desktop
 * - Category URL resolution via useCategoryUrls hook (shared with CategoryCards)
 * - Loading skeleton state
 * - Error boundary ready
 */

import { BrandCardItem } from './BrandCardItem'
import { BrandCardsSkeleton } from './BrandCardsSkeleton'
import { SectionHeader } from '../../../UiBlocks'
import { useCategoryUrls } from '../../hooks'
import { LABELS } from '../../lib'

import type { HomepageBrandCard } from '../../types'

const BRAND_CARDS_GRID_CLASSES = 'grid grid-cols-2 gap-2 md:grid-cols-3 md:gap-3 xl:grid-cols-5'

interface BrandCardsGridProps {
  cards: HomepageBrandCard[]
  isLoading?: boolean
}

export function BrandCardsGrid({ cards, isLoading }: BrandCardsGridProps) {
  const { categoryUrlMap, isLoading: isLoadingUrls } = useCategoryUrls(cards)

  if (isLoading || isLoadingUrls) {
    return <BrandCardsSkeleton />
  }

  if (cards.length === 0) return null

  return (
    <>
      <SectionHeader size="lg" centered>{LABELS.BRAND_SECTION_TITLE}</SectionHeader>
      <div className={BRAND_CARDS_GRID_CLASSES}>
        {cards.map((card) => (
          <BrandCardItem
            key={card.id}
            card={card}
            resolvedUrl={categoryUrlMap.get(card.link_value)}
          />
        ))}
      </div>
    </>
  )
}
